import { render } from "./WeaponsDisplay.vue?vue&type=template&id=3850b2ca&scoped=true"
import script from "./WeaponsDisplay.vue?vue&type=script&lang=js"
export * from "./WeaponsDisplay.vue?vue&type=script&lang=js"

import "./WeaponsDisplay.vue?vue&type=style&index=0&id=3850b2ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3850b2ca"]])

export default __exports__